import { numberWithCurrency } from 'hb-react/shared/utils/formatNumber';

const applyPromoCode = (amount, off, currency) => {
  const roundedFloat = Math.fround((amount / 100) * (100 - off));

  return currency.has_cents ? roundedFloat : Math.round(roundedFloat);
};

export const getDiscountValues = ({ valueOff, price, currency }) => {
  if (!valueOff || !price) {
    return {
      valueOff: null,
      oldPrice: null,
      newPrice: null,
    };
  }

  return {
    valueOff,
    oldPrice: numberWithCurrency(price, currency, {
      currencyDisplay: 'symbol',
    }),
    newPrice: numberWithCurrency(
      applyPromoCode(price, valueOff, currency),
      currency,
      {
        currencyDisplay: 'symbol',
      },
    ),
  };
};
